"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SectionStatus = function SectionStatus(_ref) {
  var status = _ref.status,
    className = _ref.className;
  if (status === _utils.NoteSectionStatus.Incomplete) {
    return /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
      type: "warning",
      className: className
    }, status);
  }
  if (status === _utils.NoteSectionStatus.Complete) {
    return /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
      type: "success",
      className: className
    }, status);
  }
  return null;
};
exports.SectionStatus = SectionStatus;